// 유튜브 IFrame Player API 로더.
// 스크립트는 페이지당 한 번만 붙이고, 준비되면 같은 Promise 를 모두에게 돌려준다.
// (미디어 섹션에 플레이어가 9개라 각자 로드하면 안 된다.)

const SRC = 'https://www.youtube.com/iframe_api'

let ready = null

export function loadYouTubeIframeApi() {
  if (ready) return ready

  ready = new Promise((resolve) => {
    if (window.YT?.Player) {
      resolve(window.YT)
      return
    }

    // API 는 전역 콜백 하나만 부른다. 이미 걸려 있으면 이어서 부른다.
    const prev = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      prev?.()
      resolve(window.YT)
    }

    if (!document.querySelector(`script[src="${SRC}"]`)) {
      const tag = document.createElement('script')
      tag.src = SRC
      document.head.appendChild(tag)
    }
  })

  return ready
}
